import { client } from "./API";


const WaterfallDetailsService = {
    async getWaterfallDetails(
        userId: number,
    ) {
        const url = `Project/GetWaterfallDetails/${userId}`
        const response = await client({
            url: url,
            method: "get",
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
            }
        })
        return response.data;
    }
}

export default WaterfallDetailsService